import * as types from '@/store/mutation-types';

const mutations = {
  [types.UPDATE_HEADER_TEXT](state, p) {
    const drp = p.drp;
    drp.text = p.text;
  },
};

const actions = {
  async setHeaderText({ dispatch, commit }, payload) {
    await commit(types.UPDATE_HEADER_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/header/vuex.js